import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "context-menu-container"
};
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
export default {
  __name: 'index',
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    const onRefreshClick = () => {
      router.go(0);
    };
    const store = useStore();
    const onCloseRightClick = () => {
      store.commit('app/removeTagsView', {
        type: 'right',
        index: props.index
      });
    };
    const onCloseOtherClick = () => {
      store.commit('app/removeTagsView', {
        type: 'other',
        index: props.index
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("ul", _hoisted_1, [_createElementVNode("li", {
        onClick: onRefreshClick
      }, _toDisplayString(_ctx.$t('msg.tagsView.refresh')), 1), _createElementVNode("li", {
        onClick: onCloseRightClick
      }, _toDisplayString(_ctx.$t('msg.tagsView.closeRight')), 1), _createElementVNode("li", {
        onClick: onCloseOtherClick
      }, _toDisplayString(_ctx.$t('msg.tagsView.closeOther')), 1)]);
    };
  }
};